import Api from '../http.service';
/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Object} payload.data
 * @param {String} payload.data.phrase
 */
export const searchCustomer = (payload) =>
  Api.POST({ data: payload.data, url: `customer/search/${payload.profileId}` });

/** get all customer
 * @param {Object} payload
 * @param {Number} payload.profileId
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.phrase
 * @param {Boolean} payload.data.isBusiness
 * @param {Boolean} payload.data.isActive
 */
export const fetchAllCustomer = (payload) =>
  Api.POST({
    data: payload.data,
    url: `customer/all/${payload.profileId}/${payload.pageNumber - 1}/${
      payload.itemPerPage
    }`,
  });

/**
 * insert Customer
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.businessType
 * @param {String} payload.data.fullName
 * @param {String} payload.data.identificationNo
 * @param {String} payload.data.phone
 * @param {String} payload.data.email
 * @param {String} payload.data.address
 * @param {String} payload.data.birthDate
 * @param {Boolean} payload.data.status
 * @param {String} payload.data.economyCode
 * @param {String} payload.data.postalCode
 * @param {String} payload.data.code
 * @param {String} payload.data.fax
 * @param {String} payload.data.nationalNo
 */

export const insert = (payload) =>
  Api.POST({ url: 'customer/add_customer', data: payload.data });

/**
 * update Customer
 * @param {String} payload.data._id
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.businessType
 * @param {String} payload.data.fullName
 * @param {String} payload.data.identificationNo
 * @param {String} payload.data.phone
 * @param {String} payload.data.email
 * @param {String} payload.data.address
 * @param {String} payload.data.birthDate
 * @param {Boolean} payload.data.status
 * @param {String} payload.data.economyCode
 * @param {String} payload.data.postalCode
 * @param {String} payload.data.code
 * @param {String} payload.data.fax
 * @param {String} payload.data.nationalNo
 *
 */

export const update = (payload) =>
  Api.PUT({ url: 'customer', data: payload.data });

/**
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.businessType
 * @param {String} payload.data.status
 */
export const addingCustomer = (payload) =>
  Api.POST({ data: payload.data, url: 'customer' });

/**
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.businessType
 * @param {String} payload.data.status
 */
export const updatingCustomer = (payload) =>
  Api.PUT({ data: payload.data, url: 'customer' });

/**
 * fetch delete customer
 * @param {Object} payload
 * @param {Number} paylaod._id
 */
export const remove = (_id) => Api.DELETE({ url: 'customer', data: _id });
